<template>
    <Bar
      v-if="chartDataReady"
      id="invoice-processing-time-chart"
      :options="chartOptions"
      :data="chartData"
      ref="myChart"
    />
  </template>
  
  <script>
  import { Bar } from 'vue-chartjs';
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
  } from 'chart.js';
  
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
  
  export default {
    name: 'InvoiceLineBucketsPerformance',
    components: { Bar },
    props: {
      reportDate: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        fetchedData: [],
        chartData: {
          labels: [], // Labels for the time buckets (based on line count ranges)
          datasets: [
            {
              label: 'Average Processing Time (seconds)',
              backgroundColor: 'rgba(75, 192, 192, 0.7)', // Bar color
              data: [], // Data for average processing time
              datalabels: {
                anchor: 'center',
                align: 'center',
                color: '#000',
                backgroundColor: 'rgba(211, 211, 211, 0.8)', // Light grey background
                borderColor: 'rgba(0, 0, 0, 0.1)', // Subtle border
                borderWidth: 1,
                borderRadius: 4, // Rounded corners
                padding: 4,
                font: {
                  weight: 'bold'
                },
                formatter: Math.round // Round numbers
              }
            }
          ]
        },
        chartOptions: {
          responsive: true,
          scales: {
            x: {
              title: {
                display: true,
                text: 'Number of Lines',
              },
            },
            y: {
              title: {
                display: true,
                text: 'Average Processing Time (seconds)',
              },
            },
          },
          plugins: {
            title: {
              display: true,
              text: "Invoice Processing Time by Number of Lines",
              font: {
                size: 18, // Title font size
              },
              padding: {
                top: 10,
                bottom: 20,
              }
            },
            legend: {
              position: 'top',
            },
          },
        },
        chartDataReady: false, // Control when to render the chart
      };
    },
    async mounted() {
      await this.fetchData(this.reportDate); // Fetch data when the component mounts
    },
    watch: {
      reportDate(newDate) {
        this.fetchData(newDate); // Re-fetch data when the date prop changes
      }
    },
    methods: {
      async fetchData(date) {
        try {
          const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}invoice-line-buckets?date=${date}`);
          const data = await response.json();
          console.log('Invoice processing Line buckets:', data);
  
          if (data && data.length > 0) {
            this.fetchedData = data;
            // Populate the chart data
            this.chartData.labels = data.map((entry) => entry.line_bucket);
            this.chartData.datasets[0].data = data.map((entry) => entry.average_processing_time); // Update to use average_processing_time
  
            // Trigger the chart rendering
            this.chartDataReady = false;
            this.$nextTick(() => {
              this.chartDataReady = true;
            });
          }
          console.log('Updated chart data:', this.chartData);
        } catch (error) {
          console.error('Error fetching invoice processing time buckets:', error);
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .chart-container {
    max-width: 800px; /* Restrict the maximum width */
    width: 100%; /* Allow the container to use up to 100% of its parent's width */
    height: 100%; /* Ensure the container takes up full height */
    display: flex; /* Flexbox for alignment */
    align-items: stretch; /* Stretch to fill the available height */
    justify-content: center; /* Center the chart horizontally */
  }
  
  #invoice-processing-time-chart {
    flex: 0 1 auto; /* Prevent the chart from growing beyond its content width */
    width: 100%; /* Ensure the chart uses the full available width within its container */
    height: 100%; /* Ensure the chart uses full height */
  }
  </style>
  